import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Paragraph } from '../models/paragraph';
import { createParagraphEndpoint } from './const';

export const createParagraph = (paragraph: Paragraph) => {
    return getHttpClient().post({ url: createParagraphEndpoint, data: JSON.stringify(paragraph) });
};
